import { render, staticRenderFns } from "./ListPanelToday.vue?vue&type=template&id=b61830aa&scoped=true&"
import script from "./ListPanelToday.vue?vue&type=script&lang=js&"
export * from "./ListPanelToday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61830aa",
  null
  
)

export default component.exports